module.exports = __webpack_public_path__ + "static/rageclicks-513028a82b8d807b021e2e0c7ed3d613.png";